import { Scale, ListChecks, Lock, Landmark } from "lucide-react";
import { Chapter, FadeUp } from "@/components/Reveal";

const CARDS = [
  {
    icon: Scale,
    title: "Rigueur",
    text: "Analyses intrinsèques sans concession.",
    testid: "pourquoi-card-rigueur",
  },
  {
    icon: ListChecks,
    title: "Méthode",
    text: "Processus structuré, du diagnostic jusqu'au suivi d'exécution.",
    testid: "pourquoi-card-methode",
  },
  {
    icon: Lock,
    title: "Confidentialité",
    text: "Une protection absolue de vos données stratégiques.",
    testid: "pourquoi-card-confidentialite",
  },
  {
    icon: Landmark,
    title: "Pérennité",
    text: "Un objectif unique : préserver la trésorerie et restaurer la valeur.",
    testid: "pourquoi-card-perennite",
  },
];

export default function Pourquoi() {
  return (
    <section id="pourquoi-acs" className="bg-slate-900" data-testid="pourquoi-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-24 sm:py-28">
        <FadeUp>
          <Chapter index="05" label="Pourquoi ACS" />
        </FadeUp>
        <FadeUp delay={0.1}>
          <h2 className="mt-8 max-w-3xl font-sans font-extrabold text-white text-3xl sm:text-4xl leading-[1.15] tracking-tight">
            Quand l'analyse financière rencontre la réalité du terrain.
          </h2>
        </FadeUp>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CARDS.map((c, i) => (
            <FadeUp key={c.title} delay={0.08 * i}>
              <div
                data-testid={c.testid}
                className="group bg-slate-800/50 border border-slate-700 rounded-2xl p-6 h-full transition-colors duration-500 hover:bg-slate-800"
              >
                <c.icon
                  strokeWidth={1.25}
                  className="w-8 h-8 text-white transition-transform duration-500 group-hover:-translate-y-1"
                />
                <h3 className="mt-6 font-sans font-bold text-white text-lg">{c.title}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{c.text}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
